import { AlphaFBoxOutlineIcon } from './AlphaFBoxOutlineIcon';

/**
 * author: Contributors
 * id 304C0008-2989-4DC9-8927-AE51F7B44F6C
 * name alpha-f-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-f-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterFBoxOutlineIcon = AlphaFBoxOutlineIcon;
export default LetterFBoxOutlineIcon